module.exports = __webpack_public_path__ + "img/thumb-004-05.04a32a08.png";